import React, { useEffect, useState } from "react";
import eventEmitter from "../../../shared/events";

import Loader from "../../loader/loader";

import { getProducts } from "../upcs/lib/upcData";
import { getAttributesByGroup } from "../../attributes/lib/attribute-data";
import { UpcsProvider } from "./index";
import { arrayToObjectByKey } from "shared/helpers";

const Upcs = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [attributeDefinitions, setAttributeDefinitions] = useState({});
    const [upcs, setUpcs] = useState([]);

    useEffect(() => {
        const init = async () => {
            const shipmentAttributes = await getAttributesByGroup("IntakeShipment");
            const upcData = await getProducts(props.shipmentKey);

            setAttributeDefinitions(arrayToObjectByKey(shipmentAttributes, "uuid"));
            setUpcs(upcData);
            setIsLoaded(true);
        };

        init();

        eventEmitter.on("NOTE_ADDED", refreshUpcs);
        eventEmitter.on("SHIPMENT_INFO_SAVED", fetchUpcs);

        return () => {
            eventEmitter.removeListener("NOTE_ADDED", refreshUpcs);
            eventEmitter.removeListener("SHIPMENT_INFO_SAVED", fetchUpcs);
        };
    }, []);

    const refreshUpcs = async () => {
        const upcData = await getProducts(props.shipmentKey);
        setUpcs(upcData);
    };
    const fetchUpcs = async (shouldUpdate) => {
        if (shouldUpdate) {
            const upcData = await getProducts(props.shipmentKey);
            setUpcs(upcData);
        }
    };

    const updateUpc = async (updatedUpc) => {
        const updatedUpcs = upcs.map((u) => {
            if (u.key === updatedUpc.key) {
                return updatedUpc;
            }

            return u;
        });
        setUpcs(updatedUpcs);
    };

    const addUpc = async (newUpc) => {
        setUpcs([...upcs, { ...newUpc }]);
    };
    const removeUpc = (key) => {
        const filteredUpcs = upcs.filter((u) => u.key !== key);
        setUpcs(filteredUpcs);
    };

    if (!isLoaded) {
        return (
            <div>
                <Loader natural={true} />
            </div>
        );
    }

    return <UpcsProvider value={{ attributeDefinitions, upcs, addUpc, removeUpc, updateUpc }}>{props.children}</UpcsProvider>;
};

export default Upcs;
